import { EventDispatcher } from 'three'

/**
 * 场景管理
 */
class SceneMana extends EventDispatcher {
  constructor(main, domContainer) {
    super()
    this.domContainer = domContainer
    this.renderMain = main
    this.scenes = []
  }

  changeScene(scene = 'main') {
    let getScene = null
    getScene = this.getScene(scene)
    if (!getScene) {
      throw new Error('场景(' + scene + ')创建失败!')
    }
    this.curScene = getScene
    this.renderMain.setScene(getScene)
    this.renderMain.enabled = true
  }

  getScene(scene) {
    let iscene = null
    iscene = this.scenes[scene]
    if (!iscene) {
      throw new Error(`没有场景<<${scene}>>`)
    }
    return iscene
  }

  setScene(name, scene) {
    this.scenes[name] = scene
  }

  updata(delta) {
    if (this.curScene) {
      this.curScene.update(delta)
    }
  }
}

export { SceneMana }



// WEBPACK FOOTER //
// ./src/webgl/SceneMana.js